// https://gist.github.com/necolas/1c494e44e23eb7f8c5864a2fac66299a#gistcomment-3110594
import { isHoverEnabled } from './HoverState';
import React from 'react';
const Hoverable = (props) => {
    const { onHoverIn, onHoverOut, children } = props;
    const [isHovered, setHovered] = React.useState(false);
    const [showHover, setShowHover] = React.useState(true);
    function handleMouseEnter() {
        if (isHoverEnabled() && !isHovered) {
            if (onHoverIn)
                onHoverIn();
            setHovered(true);
        }
    }
    function handleMouseLeave() {
        if (isHovered) {
            if (onHoverOut)
                onHoverOut();
            setHovered(false);
        }
    }
    // [TODO]
    //  - onPressIn and onPressOut may be available in later versions of RN/RNWeb
    //  - Commentout for now
    // function handleGrant() {
    //   setShowHover(false);
    // }
    // function handleRelease() {}
    const child = typeof children === 'function'
        ? children(showHover && isHovered)
        : children;
    return React.cloneElement(React.Children.only(child), {
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        // prevent hover showing while responder
        onResponderGrant: () => setShowHover(false),
        onResponderRelease: () => setShowHover(true),
    });
};
Hoverable.displayName = 'Hoverable';
export default Hoverable;
//# sourceMappingURL=Hoverable.js.map